import React, { useEffect, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import * as S from './style';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { useSelector } from 'react-redux'
import Image from '../../loggedout/common/Image';
import MentorImg from '~images/onboarding/mentor.png';
import SideIcon from '~images/onboarding/side-icon.svg';
import { redirectToDashboard } from '../helper/helper';
import { GetMentorTags } from '../../../services/parent-api';

const MentorMapping = ({ isNextStep, goToNextHandler }) => {
  const [animate, setAnimate] = useState(false);
  const [showLoadThrough, setShowLoadThrough] = useState(false); 
  const { getItem, deleteAll } = useExtendedLocalStorage('splashverse-onboarding', '');
  const [mentorInfo, setMentorInfo] = useState();
  const { selectedGrade, childScreenName } = useSelector((state) => {
    return {
      selectedGrade: state.selectedGrade,
      childScreenName: state.childScreenName
    };
  });

  const getMentorTags = async () =>{
    try{
      var mentorTags = await GetMentorTags();
    }catch(error){
      console.error('Mentor tags api failed');
    }
    let mentorInfo = {
      mentor_details : {mentor_exp: 10,
      mentor_name: "Tanya"
      }
    }     

    setMentorInfo({...mentorInfo, ...mentorTags});

    if (mentorInfo && mentorInfo.mentor_details) {
      trackAnalyticsEvent('LP Intro Screen Viewed', {
        Grade: selectedGrade,
        Tags: (mentorTags && mentorTags.tags) || [],
        'Mentor Name': mentorInfo.mentor_details.mentor_name,
        'Years of experience': mentorInfo.mentor_details.mentor_exp,
      });
    }
  }

  useEffect(() => {
    try{
      getMentorTags();
      setTimeout(() => {
        setShowLoadThrough(true);
      }, 100);
      setTimeout(() => {
        setShowLoadThrough(false);
        setTimeout(() => {
          setAnimate(true)
        }, 600)
      }, 5100);
    }
    catch(err){
      console.log(err);
    }
  }, [])

  let mentorName,mentorExp,mentorTags;
  if(mentorInfo && mentorInfo.mentor_details){
    let mentorDetails = mentorInfo.mentor_details
    mentorName = mentorDetails.mentor_name
    mentorExp = mentorDetails.mentor_exp
    mentorTags = mentorInfo.tags
  }

  const btnHandler = () => {
    if (mentorInfo && mentorInfo.mentor_details) {
      trackAnalyticsEvent('LP Intro Screen Interacted', {
        'Clicked on': 'Continue',
        Grade: selectedGrade,
        Tags: mentorInfo.tags,
        'Mentor Name': mentorInfo.mentor_details.mentor_name,
        'Years of experience': mentorInfo.mentor_details.mentor_exp,
      });
    }

   //redirect to dashboard
  redirectToDashboard({deleteAll, redirectToLPBookingScreen: true});
  }
  

  return (
    <S.ContainerWrapper>
      {!animate && (
        <Transition in={showLoadThrough} timeout={500}>
          {(state) => (
            <S.LoadThrough state={state}>
              <p>Great!</p>
              <p>
                Matching you with the right Learning Partner based on your
                responses...
              </p>
            </S.LoadThrough>
          )}
        </Transition>
      )}

      {!showLoadThrough && (
        <Transition in={animate} timeout={500}>
          {(state) => (
            <SS.OnboardingStepWrapper
              state={state}
              isNextStep={isNextStep}
              mentorMap={true}
            >
              <div>
                <SS.StepHeader>
                  Meet {mentorName}, your Learning Partner
                </SS.StepHeader>
                <SS.StepSubheader>
                All our plans include 1 free session with your Learning Partner
                </SS.StepSubheader>
              </div>
              <S.InfoBox>
                <S.LpImage>
                  <Image src={MentorImg} />
                </S.LpImage>
                <S.LpContent>

                  <S.AboutSection>
                    <p>
                    {mentorName} is a mentor and
                    tutor at SplashLearn with over {mentorExp} years of experience 
                    teaching children math and reading online.
                    </p>
                  </S.AboutSection>
                  <S.LabelText>
                    {mentorName}'s specialities
                  </S.LabelText>
                  <S.LpTagsContainer>
                    {mentorTags && mentorTags[0] && (
                      <S.LPTag fillColor="#4BB29E">{mentorTags[0]}</S.LPTag>
                    )}
                    {mentorTags && mentorTags[1] && (
                      <S.LPTag fillColor="#2284E2">{mentorTags[1]}</S.LPTag>
                    )}
                  </S.LpTagsContainer>
                </S.LpContent>
                <S.EdgeIcon>
                  <Image src={SideIcon} />
                </S.EdgeIcon>
              </S.InfoBox>
              <S.CTAContainer>
                <button onClick={btnHandler}>Got it</button>
              </S.CTAContainer>
            </SS.OnboardingStepWrapper>
          )}
        </Transition>
      )}
    </S.ContainerWrapper>
  );
}

export default MentorMapping;